import roles from '../constants/roles';

const MenuOpcoes = [
  {
    icone: require('../Icones/icon dashboard.svg').default,
    tag: 'Dashboard',
    nome: 'Dashboard',
    navega: '/DashboardAmbiente',
    alt: '/Dashboard',
    roles: [],
  },
  {
    icone: require('../Icones/icon usuarios.svg').default,
    tag: 'users',
    nome: 'Usuários',
    navega: '/users',
    roles: ['OWNER'],
  },
  {
    icone: require('../Icones/icon ambiente.svg').default,
    tag: 'Ambiente',
    nome: 'Ambiente',
    navega: '/Ambientes',
    roles: [],
  },
  {
    icone: require('../Icones/icon sensores.svg').default,
    tag: 'sensors',
    nome: 'Sensores',
    navega: '/sensors',
    roles: [],
  },
  {
    icone: require('../Icones/icon atuadores.svg').default,
    tag: 'actuator',
    nome: 'Atuadores',
    navega: '/actuators',
    roles: [],
  },
  {
    icone: require('../Icones/desumidificador icon.svg').default,
    tag: 'dehumidifier',
    nome: 'Desumidificadores',
    navega: '/dehumidifier',
    roles: [],
  },
  {
    icone: require('../Icones/icon alertas.svg').default,
    tag: 'Alertas',
    nome: 'Alertas',
    navega: '/alerts',
    roles: [],
  },
  {
    icone: require('../Icones/icon relatorios.svg').default,
    tag: 'Relatorio',
    nome: 'Relatório',
    navega: '/report',
    roles: [],
  },
  // {
  //   icone: require('../Icones/icon config.svg').default,
  //   tag: 'Configuracoes',
  //   nome: 'Configurações',
  //   navega: '/Configuracoes',
  // },
];

export default MenuOpcoes;
